import { Typography, withStyles } from '@material-ui/core';
import styled from 'styled-components';

export const CardRoot = styled.div<{ $isFocused: boolean }>`
  border: 1px solid #948f8f;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s linear;
  heigth: 57px;

  background-image: ${props => props.$isFocused && 'linear-gradient(90deg, #702BF4 0%, #1589FB 100%)'};

  * {
    fill: ${props => props.$isFocused && '#fff'};
    color: ${props => props.$isFocused && '#fff'};
  }

  button {
    visibility: ${props => props.$isFocused && 'visible'};
  }



  p {
    font-family: "Roboto", "Monteserrat";
    color: ${props => props.$isFocused && '#fff'};
  }

  :hover {
    background-image: linear-gradient(90deg, #702BF4 0%, #702BF4 100%);

    button {
      visibility: visible;
    }

    p {
      font-family: "Roboto", "Monteserrat";
      color: #fff;
    }

    
  }
`;

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5;
  padding: 0px 4px;
  font-family: "Roboto", "Monteserrat";

  > div {
    padding: 6px;
  }

  /* :hover {
    * {
      color: #fff;
      fill: #fff;
    }
  } */
`;

export const ProfileTypography = withStyles((theme: any) => ({
  root: {
    fontFamily: '"Roboto", "Monteserrat"',
    fontSize: 14,
    fontWeight: 400,
    color: "#7F7F7F",
    
  }
}))(Typography);

export const LocationTypography = withStyles((theme: any) => ({
  root: {
    fontFamily: '"Roboto", "Monteserrat"',
    fontSize: 14,
    fontWeight: 500,
    color: "#7F7F7F",
  },
}))(Typography);